class HeaderMenu {
  constructor() {
    this.menu = document.querySelector(".header__menu");
    this.toggle = document.querySelector("[data-menu-toggle]");
    this.closeBtn = document.querySelector(".header__menu-close");
    this.searchForm = document.querySelector(".header__search-form");
    this.searchToggle = document.querySelector("[data-search-toggle]");
    this.searchInput = this.searchForm?.querySelector(".header__search-input");

    if (!this.menu || !this.toggle || !this.closeBtn) return;

    this.#bindEvents();
  }

  #bindEvents() {
    this.toggle.addEventListener("click", () => this.#open());
    this.closeBtn.addEventListener("click", () => this.#close());
    document.addEventListener("click", (e) => this.#handleClickOutside(e));
    document.addEventListener("keydown", (e) => this.#handleKeydown(e));
  }

  #getFocusableElements() {
    return [...this.menu.querySelectorAll(FOCUSABLE_SELECTORS)].filter((el) => {
      const style = getComputedStyle(el);
      return style.display !== "none" && style.visibility !== "hidden";
    });
  }

  #open() {
    this.#closeSearch();
    this.menu.classList.add("is-open");
    this.toggle.setAttribute("aria-expanded", "true");
    document.activeElement?.blur();
  }

  #handleClickOutside(e) {
    if (!this.menu.classList.contains("is-open")) return;

    const isClickInsideMenu = this.menu.contains(e.target);
    const isClickOnToggle = this.toggle.contains(e.target);

    if (!isClickInsideMenu && !isClickOnToggle) {
      this.#close();
    }
  }

  #closeSearch() {
    if (!this.searchForm || this.searchForm.getAttribute("aria-hidden") === "true") return;

    this.searchForm.setAttribute("aria-hidden", "true");
    this.searchToggle?.setAttribute("aria-expanded", "false");

    if (this.searchInput) {
      this.searchInput.value = "";
    }
  }

  #close() {
    this.menu.classList.remove("is-open");
    this.toggle.setAttribute("aria-expanded", "false");
    document.activeElement?.blur();
  }

  #handleKeydown(e) {
    if (!this.menu.classList.contains("is-open")) return;

    if (e.key === "Escape") {
      this.#close();
      return;
    }

    if (e.key !== "Tab") return;

    const focusableElements = this.#getFocusableElements();
    if (focusableElements.length === 0) return;

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];
    const currentIndex = focusableElements.indexOf(document.activeElement);

    if (e.shiftKey) {
      if (currentIndex <= 0) {
        e.preventDefault();
        lastElement.focus();
      }
      return;
    }

    if (currentIndex === -1 || currentIndex >= focusableElements.length - 1) {
      e.preventDefault();
      firstElement.focus();
    }
  }
}

class HeaderSearch {
  constructor() {
    this.toggle = document.querySelector("[data-search-toggle]");
    this.form = document.querySelector(".header__search-form");
    this.closeBtn = document.querySelector("[data-search-close]");
    this.searchForm = this.form?.querySelector("form");
    this.input = this.form?.querySelector(".header__search-input");
    this.submitBtn = document.querySelector("[data-search-submit]");

    if (!this.toggle || !this.form || !this.closeBtn || !this.input || !this.searchForm) return;

    this.#bindEvents();
  }

  #bindEvents() {
    this.toggle.addEventListener("click", () => this.#open());
    this.closeBtn.addEventListener("click", () => this.#close());
    this.submitBtn?.addEventListener("click", (e) => this.#handleSubmit(e));
    document.addEventListener("keydown", (e) => this.#handleKeydown(e));
  }

  #handleSubmit(e) {
    if (!this.input.value.trim()) {
      e.preventDefault();
      return;
    }

    this.searchForm.submit();
  }

  #open() {
    this.form.setAttribute("aria-hidden", "false");
    this.toggle.setAttribute("aria-expanded", "true");

    this.form.addEventListener("transitionend", () => this.input.focus(), { once: true });
  }

  #close() {
    this.form.setAttribute("aria-hidden", "true");
    this.toggle.setAttribute("aria-expanded", "false");
    this.input.value = "";
    this.toggle.focus();
  }

  #handleKeydown(e) {
    if (e.key === "Escape" && this.form.getAttribute("aria-hidden") === "false") {
      this.#close();
    }
  }
}

const initHeader = () => {
  new HeaderMenu();
  new HeaderSearch();
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initHeader);
} else {
  initHeader();
}
